// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1__OW","cls2":"CiterightLanding-cls2_p08 CiterightLanding-cls1__OW"};